export type RootPower = Record<
  | '/welcome'
  | '/hardware'
  | '/hardware/manage'
  | '/hardware/binding'
  | '/hardware/advertisement'
  | '/merchant'
  | '/merchant/canteen'
  | '/merchant/brand'
  | '/merchant/shop/score'
  | '/merchant/shop/qualifications'
  | '/merchant/wish'
  | '/merchant/shop'
  | '/merchant/shop/manage'
  | '/merchant/customerAbutment'
  | '/merchant/customerAccount'
  | '/merchant/valuation'
  | '/merchant/notice'
  | '/merchant/guide'
  | '/merchant/manage'
  | '/merchant/manage/manage'
  | '/merchant/wish/advice'
  | '/merchant/wish/assist'
  | '/company'
  | '/company/manage'
  | '/company/manage/manage'
  | '/company/allowance'
  | '/company/useraccount'
  | '/company/manage/enterprise'
  | '/order'
  | '/order/optorder'
  | '/order/cardorder'
  | '/order/tsorder'
  | '/order/supplement'
  | '/order/liveMealStatistics'
  | '/order/shoptopayorder'
  | '/order/after'
  | '/marketing'
  | '/marketing/often-use'
  | '/marketing/record-manage'
  | '/marketing/platform-coupon'
  | '/marketing/launch-manage'
  | '/marketing/logisticssubsidies'
  | '/marketing/tool'
  | '/marketing/tool/new-welfare'
  | '/marketing/tool/task-center'
  | '/marketing/money-record'
  | '/marketing/full-reduction'
  | '/advice'
  | '/advice/comment'
  | '/advice/order-comment'
  | '/advice/manage'
  | '/advice/comment/detail'
  | '/marketing/drop-coupon'
  | '/marketing/lucky-draw'
  | '/marketing/live'
  | '/operation'
  | '/operation/business'
  | '/operation/pickmeal'
  | '/operation/assignee'
  | '/operation/device'
  | '/operation/groupaddressmanage'
  | '/operation/complaint'
  | '/chief'
  | '/chief/list'
  | '/chief/customermanage'
  | '/chief/activitymanage'
  | '/chief/benefitmanage'
  | '/chief/configurationcenter'
  | '/chief/chatmanage'
  | '/logistics'
  | '/logistics/timeMachine'
  | '/logistics/manage'
  | '/logistics/manage/gather'
  | '/logistics/manage/order'
  | '/logistics/control'
  | '/logistics/control/dispatch'
  | '/logistics/control/route'
  | '/logistics/control/path'
  | '/logistics/source'
  | '/logistics/delivery'
  | '/logistics/receptionist'
  | '/logistics/source/businessgroup'
  | '/logistics/source/transfer'
  | '/logistics/accrual'
  | '/logistics/accrual/type'
  | '/logistics/accrual/rule'
  | '/logistics/salarymanage'
  | '/logistics/schedule'
  | '/logistics/jointmanage'
  | '/logistics/jointmanage/city'
  | '/logistics/jointmanage/category'
  | '/logistics/guide'
  | '/finance'
  | '/finance/manage/advancefundsforecast'
  | '/finance/billmanage/deal-order'
  | '/finance/manage/account-manage'
  | '/finance/manage'
  | '/finance/manage/capital-divide'
  | '/finance/adjustment'
  | '/finance/adjustment/merchant-reconciliation'
  | '/finance/charge'
  | '/finance/billmanage/sheet'
  | '/finance/monthlyManage/creditList'
  | '/finance/billmanage/enterprise-collection'
  | '/finance/billmanage/offline-cost'
  | '/finance/billmanage'
  | '/finance/billmanage/billenterprise'
  | '/finance/billmanage/manual-split-account'
  | '/finance/manageReport'
  | '/finance/manageReport/income'
  | '/finance/manageReport/payin'
  | '/settle'
  | '/settle/checkbill'
  | '/settle/management'
  | '/settle/account'
  | '/settle/management/config'
  | '/settle/management/router'
  | '/settle/settlement-account-manage'
  | '/finance/billmanage/order'
  | '/finance/invoice'
  | '/finance/billmanage/merchant'
  | '/finance/manage/physicalcard'
  | '/data'
  | '/data/overview'
  | '/data/export'
  | '/data/definition'
  | '/data/account'
  | '/data/customergroup'
  | '/data/coredata'
  | '/data/dataNorm'
  | '/data/dataNormAction'
  | '/data/manageReport'
  | '/data/daily'
  | '/data/kpi'
  | '/privilege'
  | '/privilege/role'
  | '/privilege/account'
  | '/privilege/menu-bind'
  | '/privilege/post-management'
  | '/privilege/auth-point'
  | '/settings'
  | '/settings/info'
  | '/settings/auth'
  | '/finance/manage/balance'
  | '/finance/manage/balancemanage'
  | '/environmental'
  | '/environmental/rule'
  | '/environmental/shopmanage'
  | '/environmental/datamanage'
  | '/configure'
  | '/configure/messagemanage'
  | '/operation/regionmanage'
  | '/operation/regionmanage/region'
  | '/operation/regionmanage/area'
  | '/tool'
  | '/tool/targetcomponent'
  | '/marketing/redpacket-manage'
  | '/merchant/printtemplate'
  | '/merchant/snackcabinet'
  | '/goods'
  | '/goods/menumanage'
  | '/goods/menumanage/detail'
  | '/goods/food-library'
  | '/user'
  | '/user/userinfo'
  | '/user/useroperate'
  | '/user/order-remind'
  | '/user/advertisement'
  | '/user/notice'
  | '/message'
  | '/message/shortmsg'
  | '/message/pushRecord'
  | '/message/retryConfiguration'
  | '/message/template'
  | '/shoppingmall'
  | '/shoppingmall/banner'
  | '/goods/welfare'
  | '/finance/monthlyManage'
  | '/finance/monthlyManage/monthlySummary'
  | '/finance/monthlyManage/stored'
  | '/shoppingmall/renovation'
  | '/order/activityorder'
  | '/order/addOrder'
  | '/log'
  | '/log/operation'
  | '/saas-agent'
  | '/saas-agent/manage'
  | '/saas-agent/manage/detail'
  | '/saas-agent/platform'
  | '/saas-agent/bill'
  | '/school'
  | '/school/manage'
  | '/school/center',
  any
>;

// 格式化权限值为 Boolean
const booleanPower = (obj) => {
  Object.entries(obj).forEach(([key, val]) => {
    if (key === 'show' || key === 'view') {
      obj.show = !!val;
      obj.view = !!val;
    }
    if (key === 'actionMap') {
      obj.actionMap = val || {}; // 消除null，改为{}，避免结构报错
    }
    if (typeof val === 'object' && val !== null) {
      obj[key] = booleanPower(val);
    }
  });
  return obj;
};

/**
 * 获取丰食后台权限数据
 */
const getRootPower = (originalPower) => {
  const {
    BILL,
    DATA,
    FINANCE,
    LOGISTICS,
    MARKETING,
    OPERATION,
    ORDER,
    PERMISSION,
    SETTINGS,
    SHOP_MANAGE,
    CSTM_GRP,
    ECO_ACCOUNT,
    CUSTOMER_BMS,
    BUSINESS_BUS,
    CONFIGURATION,
    SETTLEMENT,
    USER,
    PRODUCTS,
    MESSAGE_PLATFORM,
    MERCHANT,
    COMPANY,
    APPRAISE,
    TOOLS,
    WELFARE_MARKET,
    LOG,
    SAAS_AGENT,
    SCHOOL,
    HARDWARE,
  } = originalPower;

  const rootPower: RootPower = {
    // 欢迎
    '/welcome': { view: 1, edit: 1 },

    // '/business/shop/merchant': BUSINESS_BUS?.subCategoryMap?.SHOP_MANAGE_BUS,
    // 企业 企业管理
    '/company': COMPANY,
    '/company/manage': {
      view:
        COMPANY?.subCategoryMap?.COMPANY_MANAGEMENT_BUS?.show ||
        COMPANY?.subCategoryMap?.COMPANY_MANAG_BMS?.show,
    },
    '/company/manage/manage': COMPANY?.subCategoryMap?.COMPANY_MANAGEMENT_BUS,
    '/company/allowance': COMPANY?.subCategoryMap?.WELFARE_ADJUST_BUS,
    '/company/useraccount': COMPANY?.subCategoryMap?.EMPLOYEE_ACCOUNT_MANAGEMENT_BUS,
    '/company/manage/enterprise': COMPANY?.subCategoryMap?.COMPANY_MANAG_BMS,

    // 订单
    '/order': ORDER,
    '/order/optorder': ORDER?.subCategoryMap?.TAKE_OUT_ORDER,
    '/order/cardorder': ORDER?.subCategoryMap?.CARD_COUPON_ORDER,
    '/order/tsorder': ORDER?.subCategoryMap?.CANTEEN_ORDER,
    '/order/supplement': ORDER?.subCategoryMap?.REPLENISH,
    '/order/liveMealStatistics': ORDER?.subCategoryMap?.LIVE_MEAL,
    '/order/activityorder': ORDER?.subCategoryMap?.EVENT_MEAL_ORDER,
    '/order/addOrder': ORDER?.subCategoryMap?.SUPPLEMENTARY_ORDER_QUERY,
    '/order/shoptopayorder': ORDER?.subCategoryMap?.SHOP_TO_PAY_ORDER,
    //  订单管理-售后订单
    '/order/after': ORDER?.subCategoryMap?.AFTER_ORDER,

    // 营销
    '/marketing': MARKETING,
    '/marketing/often-use': MARKETING?.subCategoryMap?.MARKETING_CHARGE_MKT,
    '/marketing/record-manage': MARKETING?.subCategoryMap?.MARKETING_AWARD_MGR,
    '/marketing/platform-coupon': MARKETING?.subCategoryMap?.MARKETING_COUPON_MKT,
    '/marketing/launch-manage': MARKETING?.subCategoryMap?.MARKETING_REALSE_MKT,
    '/marketing/logisticssubsidies': MARKETING?.subCategoryMap?.MARKETING_LOGISTICS_MKT,
    '/marketing/tool': MARKETING?.subCategoryMap?.MARKETING_TOOL_MKT,
    '/marketing/tool/new-welfare': MARKETING?.subCategoryMap?.MARKETING_TOOL_MKT,
    '/marketing/tool/task-center': MARKETING?.subCategoryMap?.MARKETING_TOOL_MKT,
    '/marketing/money-record': MARKETING?.subCategoryMap?.MARKETING_AWARD_MKT, // 返利记录
    '/marketing/full-reduction': MARKETING?.subCategoryMap?.DEDUCTIONACTIVITY,
    '/marketing/redpacket-manage': MARKETING?.subCategoryMap?.RED_POCKET,
    '/marketing/drop-coupon': { view: 1, edit: 1 },
    '/marketing/lucky-draw': { view: 1, edit: 1 },
    '/marketing/live': { view: 1, edit: 1 },

    // 营销 - 评价
    '/advice': APPRAISE,
    '/advice/comment': APPRAISE?.subCategoryMap?.MARKETING_RAISE_MKT,
    '/advice/comment/detail': APPRAISE?.subCategoryMap?.MARKETING_RAISE_MKT,
    '/advice/order-comment': APPRAISE?.subCategoryMap?.ORDER_COMMENT,
    '/advice/manage': APPRAISE?.subCategoryMap?.MARKETING_SUG_MKT,

    // 营运
    '/operation': OPERATION,
    '/operation/business': OPERATION?.subCategoryMap?.CBD,
    '/operation/pickmeal': OPERATION?.subCategoryMap?.TAKE_MEAL_GROUP,
    '/operation/assignee': OPERATION?.subCategoryMap?.ASSIGNEE,
    '/operation/groupaddressmanage': OPERATION?.subCategoryMap?.TAKE_MEAL_MANGER,
    '/operation/regionmanage': {
      view:
        OPERATION?.subCategoryMap?.LARGE_AREA_MANAGEMENT?.show ||
        OPERATION?.subCategoryMap?.AREA_MANAGEMENT?.show,
    },
    '/operation/regionmanage/region': OPERATION?.subCategoryMap?.LARGE_AREA_MANAGEMENT,
    '/operation/regionmanage/area': OPERATION?.subCategoryMap?.AREA_MANAGEMENT,
    '/operation/complaint': OPERATION?.subCategoryMap?.COMPLAINT_MANAGER,
    '/operation/device': OPERATION?.subCategoryMap?.DEVICE_MANAGER,

    // 饭圈
    '/chief': CSTM_GRP,
    '/chief/list': CSTM_GRP?.subCategoryMap?.CSTM_GRP_MASTER_MNG,
    '/chief/customermanage': CSTM_GRP?.subCategoryMap?.CSTM_GRP_MNG,
    '/chief/activitymanage': CSTM_GRP?.subCategoryMap?.CSTM_GRP_ACT_MNG,
    '/chief/benefitmanage': CSTM_GRP?.subCategoryMap?.CSTM_GRP_AWARD_MNG,
    '/chief/configurationcenter': CSTM_GRP?.subCategoryMap?.CUSTOMER_GROUP_SETTING_CENTER,
    '/chief/chatmanage': CSTM_GRP?.subCategoryMap?.CHATMANAGE,

    // 物流
    '/logistics': LOGISTICS,
    // 物流 - 订单管理
    '/logistics/manage': {
      view:
        LOGISTICS?.subCategoryMap?.ORDER_AGGREGATION?.show ||
        LOGISTICS?.subCategoryMap?.MERCHANT_ORDER?.show,
    },

    '/logistics/manage/gather': LOGISTICS?.subCategoryMap?.ORDER_AGGREGATION,
    '/logistics/manage/order': LOGISTICS?.subCategoryMap?.MERCHANT_ORDER,
    // 物流 - 调度管理
    '/logistics/control': {
      view:
        LOGISTICS?.subCategoryMap?.ORDER_DISPATCH?.show ||
        LOGISTICS?.subCategoryMap?.ROUTE_PLAN?.show,
    },
    '/logistics/control/dispatch': LOGISTICS?.subCategoryMap?.ORDER_DISPATCH,
    '/logistics/control/route': LOGISTICS?.subCategoryMap?.ROUTE_PLAN,
    '/logistics/control/path': LOGISTICS?.subCategoryMap?.ROUTE_PLAN_NEW,
    // 物流 - 站点管理
    '/logistics/source': {
      view:
        LOGISTICS?.subCategoryMap?.MID_TRANS_POINT?.show ||
        LOGISTICS?.subCategoryMap?.CBD_SHOP_GROUP?.show ||
        LOGISTICS?.subCategoryMap?.EMPLOYEE?.show,
    },
    '/logistics/delivery': LOGISTICS?.subCategoryMap?.DISTRIBUTION_UNIT,
    '/logistics/source/businessgroup': LOGISTICS?.subCategoryMap?.CBD_SHOP_GROUP,
    '/logistics/source/transfer': LOGISTICS?.subCategoryMap?.MID_TRANS_POINT,
    // 物流 - 薪酬计提
    '/logistics/accrual': {
      view:
        LOGISTICS?.subCategoryMap?.ACCRUAL_TYPE?.show ||
        LOGISTICS?.subCategoryMap?.ACCRUAL_RULE?.show,
    },
    '/logistics/accrual/type': LOGISTICS?.subCategoryMap?.ACCRUAL_TYPE,
    '/logistics/accrual/rule': LOGISTICS?.subCategoryMap?.ACCRUAL_RULE,

    '/logistics/salarymanage': LOGISTICS?.subCategoryMap?.SALARY_MANAGE,
    '/logistics/schedule': LOGISTICS?.subCategoryMap?.BUSINESS_SCHEDULE,
    '/logistics/timeMachine': LOGISTICS?.subCategoryMap?.TIME_MACHINE,
    // 物流-对接管理
    '/logistics/jointmanage': {
      view:
        LOGISTICS?.subCategoryMap?.ABUT_LAP_CITY?.show ||
        LOGISTICS?.subCategoryMap?.ABUT_LAP_PRODUCT_TYPE?.show,
    },
    '/logistics/jointmanage/city': LOGISTICS?.subCategoryMap?.ABUT_LAP_CITY,
    '/logistics/jointmanage/category': LOGISTICS?.subCategoryMap?.ABUT_LAP_PRODUCT_TYPE,

    '/logistics/receptionist': LOGISTICS?.subCategoryMap?.EMPLOYEE,
    '/logistics/guide': LOGISTICS?.subCategoryMap?.LOGISTICS_HOME,
    // 财务
    '/finance': FINANCE,
    '/finance/monthlyManage': {
      view:
        FINANCE?.subCategoryMap?.MONTHLY_SUMMARY?.show ||
        FINANCE?.subCategoryMap?.FINANCE_COMPANY_CHARGE_RECORD?.show ||
        FINANCE?.subCategoryMap?.FINANCE_STORE_SUMMARY?.show,
    },
    '/finance/monthlyManage/monthlySummary': FINANCE?.subCategoryMap?.MONTHLY_SUMMARY,
    '/finance/monthlyManage/stored': FINANCE?.subCategoryMap?.FINANCE_STORE_SUMMARY,
    '/finance/monthlyManage/creditList': FINANCE?.subCategoryMap?.FINANCE_COMPANY_CHARGE_RECORD,
    '/finance/manage': {
      view:
        FINANCE?.subCategoryMap?.FUNDS_TRANSFER?.show ||
        FINANCE?.subCategoryMap?.BALANCE_MANAGEMENT?.show ||
        FINANCE?.subCategoryMap?.ADVANCE_FUND?.show ||
        FINANCE?.subCategoryMap?.ACCOUNT_MANAGEMENT?.show ||
        FINANCE?.subCategoryMap?.BANK_CARD_MANAGEMEN?.show ||
        FINANCE?.subCategoryMap?.CARD?.show,
      edit: 1,
    },
    // '/finance/speciallist': FINANCE?.subCategoryMap?.FINANCE_BI,
    // '/finance/manage/advancefunds': FINANCE?.subCategoryMap?.ADVANCE_QUERY,
    '/finance/manage/advancefundsforecast': FINANCE?.subCategoryMap?.ADVANCE_FUND,
    '/finance/manage/account-manage': FINANCE?.subCategoryMap?.ACCOUNT_MANAGEMENT,
    '/finance/manage/capital-divide': FINANCE?.subCategoryMap?.FUNDS_TRANSFER,
    '/finance/adjustment': FINANCE?.subCategoryMap?.MERCHANT_RECONCILIATION,
    '/finance/adjustment/merchant-reconciliation': FINANCE?.subCategoryMap?.MERCHANT_RECONCILIATION,
    '/finance/billmanage/deal-order': FINANCE?.subCategoryMap?.FINANCE_PLATFORM,
    '/finance/manage/balance': FINANCE?.subCategoryMap?.BANK_CARD_MANAGEMENT,
    '/finance/manage/balancemanage': FINANCE?.subCategoryMap?.BALANCE_MANAGEMENT,
    '/finance/charge': {
      view:
        FINANCE?.subCategoryMap?.FINANCE_COMPANY_CHARGE_RECORD?.show ||
        FINANCE?.subCategoryMap?.FINANCE_COMPANY_CHARGE_REPORT?.show,
    },
    '/finance/billmanage/sheet': FINANCE?.subCategoryMap?.FINANCE_COMPANY_CHARGE_REPORT,
    '/finance/billmanage/enterprise-collection': FINANCE?.subCategoryMap?.COMPANY_CASH_BACK,
    '/finance/billmanage/offline-cost': FINANCE?.subCategoryMap?.OFFLINE_ENTER_COST,
    '/finance/billmanage/order': FINANCE?.subCategoryMap?.COMPANY_BILL,
    '/finance/invoice': FINANCE?.subCategoryMap?.INVOICE_MANAGEMENT,
    '/finance/billmanage': { view: 1, edit: 1 },
    '/finance/billmanage/billenterprise': FINANCE?.subCategoryMap?.BILL_MANAGEMENT,
    '/finance/billmanage/merchant': FINANCE?.subCategoryMap?.SHOP_BILL,
    '/finance/manage/physicalcard': FINANCE?.subCategoryMap?.CARD,
    '/finance/billmanage/manual-split-account': FINANCE?.subCategoryMap?.MANUAL_SPLITACCOUNT, //FIXME: 手动分账权限配置
    '/finance/manageReport': FINANCE?.subCategoryMap?.INCOME,
    '/finance/manageReport/income': FINANCE?.subCategoryMap?.INCOME,
    '/finance/manageReport/payin': FINANCE?.subCategoryMap?.PAYIN,
    // 结算
    '/settle': SETTLEMENT,
    '/settle/checkbill': SETTLEMENT?.subCategoryMap?.SETTLEMENT_CHECK_BILL,
    '/settle/management': { view: 1, edit: 1 },
    '/settle/management/config': SETTLEMENT?.subCategoryMap?.PAY_CHAHNNEL_CFG,
    '/settle/management/router': SETTLEMENT?.subCategoryMap?.PAY_CHAHNNEL_ROUTER,
    '/settle/settlement-account-manage': SETTLEMENT?.subCategoryMap?.SETTLE_ACCOUNT_MANAGE,
    '/settle/account': SETTLEMENT?.subCategoryMap?.SETTLE_ACCOUNT,
    // 数据
    '/data': DATA,
    '/data/overview': DATA?.subCategoryMap?.SUMMARY,
    '/data/export': DATA?.subCategoryMap?.DATAHUB_DATADOWNLOAD,
    '/data/definition': DATA?.subCategoryMap?.DATAHUB_DEFINE,
    '/data/account': DATA?.subCategoryMap?.MERCHANT_ANYLASIS,
    '/data/customergroup': DATA?.subCategoryMap?.CSTM_GRP_DATA_STATEMENT_MNG,
    '/data/coredata': DATA?.subCategoryMap?.DATAHUB_DASHBOARD_CORE, // 核心数据
    '/data/manageReport': DATA?.subCategoryMap?.FINANCE_MANAGEMENT_REPORT, // 管理报表
    '/data/dataNormAction': DATA?.subCategoryMap?.DATAHUB_DATAMANAGEMENT,
    '/data/dataNorm': DATA?.subCategoryMap?.DATAHUB_DATAMANAGEMENT,
    '/data/daily': DATA?.subCategoryMap?.BUSINESS_DAILY_OVERVIEW,
    '/data/kpi': DATA?.subCategoryMap?.BUSINESS_KPI,
    // 权限
    '/privilege': PERMISSION,
    '/privilege/role': PERMISSION?.subCategoryMap?.ROLE_MANAGEMENT,
    '/privilege/account': PERMISSION?.subCategoryMap?.USER_MANAGEMENT,
    // todo
    '/privilege/menu-bind': PERMISSION?.subCategoryMap?.CATEGORY_BIND,
    '/privilege/auth-point': PERMISSION?.subCategoryMap?.PERMISSION_MANAGE,
    '/privilege/post-management': PERMISSION?.subCategoryMap?.POSITION_CATEGORY,

    // 设置
    '/settings': SETTINGS,
    '/settings/info': SETTINGS?.subCategoryMap?.BASIC_INFO,
    '/settings/auth': SETTINGS?.subCategoryMap?.AUTH_MANAGEMENT,

    // 环保
    '/environmental': ECO_ACCOUNT,
    '/environmental/rule': ECO_ACCOUNT?.subCategoryMap?.ECO_CONFIG_MANAGE,
    '/environmental/shopmanage': ECO_ACCOUNT?.subCategoryMap?.ECO_SHOP_MANAGE,
    '/environmental/datamanage': ECO_ACCOUNT?.subCategoryMap?.ECO_DATA_MANAGE,

    // 配置
    '/configure': CONFIGURATION,
    '/configure/messagemanage': { view: CONFIGURATION?.subCategoryMap?.MESSAGE_NOTICE?.show },
    '/tool': TOOLS?.subCategoryMap?.TARGET,
    '/tool/targetcomponent': TOOLS?.subCategoryMap?.TARGET,

    // // 店铺
    // '/shop': SHOP_MANAGE,
    // '/shop/decoration': SHOP_MANAGE?.subCategoryMap?.SHOP_DECORATION,
    // '/shop/agent': SHOP_MANAGE?.subCategoryMap?.SHOP_MANAGEMENT,
    // '/shop/polymer-manage': SHOP_MANAGE?.subCategoryMap?.SHOP_JOIN,
    // '/shop/brand': SHOP_MANAGE?.subCategoryMap?.BRAND_JOIN,
    // '/shop/license': SHOP_MANAGE?.subCategoryMap?.SHOP_APPLY_MANAGEMENT,
    // 企业
    // '/shop/polymer-manage/detail': { view: 1, edit: 1 },
    // 商品
    '/goods': PRODUCTS,
    '/goods/menumanage': PRODUCTS?.subCategoryMap?.MENU_MANAGEMENT,
    '/goods/menumanage/detail': { view: 1, edit: 1 },
    '/goods/food-library': PRODUCTS?.subCategoryMap?.DISH_LIBRARY_LIST,
    '/goods/welfare': PRODUCTS?.subCategoryMap?.WELFARE_MALL,
    // 用户
    '/user': USER,
    '/user/userinfo': USER?.subCategoryMap?.USER_INFO,
    '/user/useroperate': USER?.subCategoryMap?.USER_CRM,
    '/user/notice': USER?.subCategoryMap?.MARKETING_ANN_MKT,
    '/user/advertisement': USER?.subCategoryMap?.MARKETING_ADV_MKT,
    '/user/order-remind': USER?.subCategoryMap?.MEAL_REMIND,

    // 消息管理
    '/message': MESSAGE_PLATFORM,
    '/message/shortmsg': MESSAGE_PLATFORM?.subCategoryMap?.SHORT_MESSAGE,
    '/message/pushRecord': MESSAGE_PLATFORM?.subCategoryMap?.MESSAGE_CENTER_RECORD,
    '/message/retryConfiguration': MESSAGE_PLATFORM?.subCategoryMap?.MESSAGE_RETRY_CONF,
    '/message/template': MESSAGE_PLATFORM?.subCategoryMap?.MESSAGE_TEMPLATE,
    //商户
    '/merchant': MERCHANT,
    //  商户-食堂管理
    '/merchant/canteen': MERCHANT?.subCategoryMap?.MERCHANT_CANTEEN,
    '/merchant/manage': MERCHANT?.subCategoryMap?.MERCHANT_MANAGEMENT,
    '/merchant/manage/manage': MERCHANT?.subCategoryMap?.MERCHANT_MANAGEMENT,
    '/merchant/shop': MERCHANT?.subCategoryMap?.SHOP_MANAGEMENT,
    '/merchant/shop/manage': MERCHANT?.subCategoryMap?.SHOP_MANAGEMENT,
    '/merchant/shop/qualifications': MERCHANT?.subCategoryMap?.SHOP_APPLY_MANAGEMENT_BUS,
    '/merchant/customerAccount': MERCHANT?.subCategoryMap?.CUSTOMER_ACCOUNT_BMS,
    '/merchant/shop/score': MERCHANT?.subCategoryMap?.SUB_GRADE_BUS,
    '/merchant/printtemplate': MERCHANT?.subCategoryMap?.PRINT_TEMPLATE,
    '/merchant/snackcabinet': MERCHANT?.subCategoryMap?.SNACK_CABINET,
    '/merchant/valuation': MERCHANT?.subCategoryMap?.COMMON_TEMPLATE,
    '/merchant/customerAbutment': MERCHANT?.subCategoryMap?.THIRD_PART_BMS,
    '/merchant/notice': MERCHANT?.subCategoryMap?.MESSAGE_NOTICE,
    '/merchant/guide': MERCHANT?.subCategoryMap?.GUIDE,
    '/merchant/wish': {
      view:
        MERCHANT?.subCategoryMap?.WISH_ADVICE?.show || MERCHANT?.subCategoryMap?.WISH_ASSIST?.show,
    },
    '/merchant/wish/advice': MERCHANT?.subCategoryMap?.WISH_ADVICE,
    '/merchant/wish/assist': MERCHANT?.subCategoryMap?.WISH_ASSIST,
    // 商户-品牌管理
    '/merchant/brand': MERCHANT?.subCategoryMap?.BRAND_JOIN_BUS,
    // 福利商城装修
    '/shoppingmall': WELFARE_MARKET,
    '/shoppingmall/renovation': WELFARE_MARKET?.subCategoryMap?.WELFARE_MARKET_ARRANGE,
    '/shoppingmall/banner': WELFARE_MARKET?.subCategoryMap?.WELFARE_MARKET_BANNER,
    '/log': LOG,
    '/log/operation': LOG?.subCategoryMap?.LOG_OPERATION,
    //  硬件
    '/hardware': HARDWARE,
    //  硬件-硬件管理
    '/hardware/manage': HARDWARE?.subCategoryMap?.HARDWARE_MANAGE,
    //  硬件-设备绑定管理
    '/hardware/binding': HARDWARE?.subCategoryMap?.HARDWARE_BINDING,
    //  硬件-广告管理
    '/hardware/advertisement': HARDWARE?.subCategoryMap?.HARDWARE_ADVERTISEMENT,
    //合作伙伴
    '/saas-agent':
      SAAS_AGENT?.subCategoryMap.SAAS_AGENT_MANAGEMENT ||
      SAAS_AGENT?.subCategoryMap.SAAS_PLATFORM_MANAGEMENT,
    '/saas-agent/manage': SAAS_AGENT?.subCategoryMap.SAAS_AGENT_MANAGEMENT,
    '/saas-agent/bill': SAAS_AGENT?.subCategoryMap.SAAS_BILL_MANAGEMENT,
    '/saas-agent/manage/detail': SAAS_AGENT?.subCategoryMap.SAAS_AGENT_MANAGEMENT,
    '/saas-agent/platform': SAAS_AGENT?.subCategoryMap.SAAS_PLATFORM_MANAGEMENT,

    // 丰食学堂
    '/school': SCHOOL,
    '/school/manage': SCHOOL?.subCategoryMap.SCHOOL_MANGE,
    '/school/center': SCHOOL?.subCategoryMap.SCHOOL_CENTER,
  };

  return booleanPower(rootPower);
};

const isDev = import.meta.env.DEV;

/**
 * 获取侧边栏菜单数据
 */
const getPoweredMenu = (menu, rootPower) => {
  const poweredMenu: any[] = []; // 根据权限数据，格式化后的侧边栏菜单

  menu.forEach((top) => {
    if (!top.children) {
      // 没有子页面 (订单、营销、权限、财务)
      const topPowerKey = top.path;
      const topPower = rootPower[topPowerKey];
      if (isDev && !topPower) {
        // eslint-disable-next-line no-console
        console.error(`请注意，rootPower['${topPowerKey}'] 的值为 ${topPower}`);
        return;
      }
      if (topPower && !!topPower.view) {
        top.view = !!topPower.view;
        poweredMenu.push(top);
      }
    } else {
      // 拥有子页面 (店铺、商品、堂食、客户、分销、数据、设置)
      const subMenu: any[] = [];
      top.children.forEach((sub) => {
        const subPowerKey = sub.path;
        const subPower = rootPower[subPowerKey];
        if (isDev && !subPower) {
          // eslint-disable-next-line no-console
          console.error(`请注意，rootPower['${subPowerKey}'] 的值为 ${subPower}`);
          return;
        }
        if (subPower && !!subPower.view) {
          sub.view = !!subPower.view;
          const childMenu: any[] = [];
          if (sub.children) {
            sub.children.forEach((child) => {
              const childPowerKey = child.path;
              const childPower = rootPower[childPowerKey];
              if (isDev && !subPower) {
                console.error(`请注意，rootPower['${childPowerKey}'] 的值为 ${childPower}`); // eslint-disable-line
                return;
              }
              if (childPower && !!childPower.view) {
                child.view = !!childPower.view;
                childMenu.push(child);
              }
            });
          }
          subMenu.push(sub.children ? { ...sub, children: childMenu } : sub);
        }
      });
      top.view = rootPower[top.path] ? !!rootPower[top.path].view : false;
      poweredMenu.push({ ...top, children: subMenu });
    }
  });
  return poweredMenu;
};

export { getRootPower, getPoweredMenu };
